import { useEffect, useState } from "react";
import { Dropdown } from "@/atoms-react/dropdown/index.react";
import { usei18n } from "@/features/utils/hooks/use-i18n";

export const RealEstate = ({
  setResponseRealEstate,
  realestateResponse
}: {
  setResponseRealEstate: (real_estate: string) => void;
  realestateResponse?: string | null;
}) => {
  const [cs, setCs] = useState<string | undefined>();
  const { getLanguage } = usei18n();

  useEffect(() => {
    if (realestateResponse && !cs) setCs(realestateResponse);
  }, [realestateResponse]);
  const civilStates = [
    {
      key: "1",
      value: "Je ne suis pas propriétaire d’un bien immobilier",
      valueEn: "I don't own a property"
    },
    {
      key: "2",
      value: "Je suis propriétaire d’un ou plusieurs bien(s) immobilier(s)",
      valueEn: "I own one or more properties"
    }
  ];

  useEffect(() => {
    const initKey = civilStates.find((cs) => {
      return cs.value === realestateResponse || cs.valueEn === realestateResponse;
    });
    setCs(initKey?.key);
  }, [realestateResponse]);

  return (
    <div className="my-4 mt-4 w-full">
      <Dropdown
        onChange={(item) => {
          if (item.value !== cs) {
            setResponseRealEstate(civilStates.find((cs) => cs.key === item.key)?.valueEn as string);
            if (typeof item.value === "string") setCs(item!.value);
          }
        }}
        required={true}
        className="w-full"
        search={true}
        value={cs}
        items={civilStates.map((cs) => {
          return {
            key: cs.key,
            value: getLanguage() === "fr" ? cs.value : cs.valueEn
          };
        })}
      />
    </div>
  );
};
